import axios from 'axios';
import { QueryResult, PriceHistoryResponse, ElectricityPricesResponse } from './types';

const BASE_URL = (process.env.NODE_ENV === 'production')
  ? 'https://api.should-cost.labs.rovjok.com'
  : 'http://localhost:8080';


const getHeaders = () => {

  let userToken = localStorage.getItem('accessToken');

  return {
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${userToken}`
    }
  }
};

export const fetchDataFromAPI = async (flowID: string, optionalProcessID: string): Promise<QueryResult[] | undefined> => {
  try {
    // Even though the internal logic treats these as numbers, we convert them to strings
    // for the API call if the backend expects strings.
    const response = await axios.post<QueryResult[]>(`${BASE_URL}/query`, {
      flowID: flowID.toString(),
      optionalProcessID: optionalProcessID.toString(),
    }, getHeaders());

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    return undefined;
  }
};

export const searchProcessAndFlows = async (searchTerm: string) => {
  try {
    const response = await axios.post(`${BASE_URL}/search`, { searchTerm }, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error searching data:', error);
    throw error;
  }
};

// Updated fetchPriceHistory function with the new type
export const fetchPriceHistory = async (hsCodes: string[]): Promise<PriceHistoryResponse | undefined> => {
  try {
    const response = await axios.post<PriceHistoryResponse>(`${BASE_URL}/snowflake/pricehistory`, {
      cmdCode: hsCodes,
    }, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching price history:', error);
    return undefined;
  }
};

// Updated function to fetch electricity prices with optional ISO2 code filtering
export const fetchElectricityPrices = async (isoCountry2Codes?: string[]): Promise<ElectricityPricesResponse | undefined> => {
  try {
    // Construct the request body, including isoCountry2Codes if provided
    const requestBody = isoCountry2Codes ? { isoCountry2Codes } : {};

    const response = await axios.post<ElectricityPricesResponse>(`${BASE_URL}/snowflake/electricityPrices`, requestBody, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching electricity prices:', error);
    return undefined;
  }
};

export async function logoutUser(url: string) {
  return (await axios.get(url, await getHeaders())).data
}

